import {
  FormBuilder,
  NonNullableFormBuilder,
  Validators,
} from '@angular/forms';
import { inject } from '@angular/core';
import { UitPlace, UitTerm } from './uit-db';
import { PatchableFormArray } from '../../util/uit/forms/patchable-form-array';
import { registerSubmitPatch } from '../../util/forms/form-submit-patch';

export type Sync<P extends string, T> = {
  [k in P]:
    | { syncStatus: 'pending'; jobId: string }
    | {
        jobId: string;
        sync: T;
        syncStatus: 'inSync' | 'outOfSync' | 'deleted';
        syncedAt: Date;
      };
};

export const createSyncCourseThemeFormGroup = (
  fb?: FormBuilder | NonNullableFormBuilder,
) => {
  fb = fb ?? inject(FormBuilder);
  return fb.group({
    uitTheme: fb.group({
      sync: fb.group({
        eventTerms: fb.array(
          [fb.control(null as unknown as UitTerm, [Validators.required])],
          [Validators.minLength(1), Validators.maxLength(1)],
        ),
        eventLabels: new PatchableFormArray([]),
        hiddenEventLabels: new PatchableFormArray([]),
      }),
    }),
  });
};

export const createSyncLocationFormGroup = (
  fb?: FormBuilder | NonNullableFormBuilder,
) => {
  fb = fb ?? inject(FormBuilder);

  const idControl = fb.control(
    { value: undefined as unknown as UitPlace, disabled: false },
    [Validators.required],
  );
  const termsControl = fb.array(
    [fb.control(null as unknown as UitTerm, [Validators.required])],
    [Validators.minLength(1), Validators.maxLength(1)],
  );

  const group = fb.group({
    uitPlace: fb.group({
      sync: fb.group({
        id: idControl,
        terms: termsControl,
        labels: new PatchableFormArray([]),
        hiddenLabels: new PatchableFormArray([]),
        eventLabels: new PatchableFormArray([]),
        hiddenEventLabels: new PatchableFormArray([]),
      }),
    }),
  });
  registerSubmitPatch(group.controls.uitPlace.controls.sync, (group, value) => {
    if (value['id'] || value['id'] === null) {
      if (typeof value['id'] !== 'string' && value['id'] !== null) {
        value['id'] = value['id']['@id'].split('/').slice(-1)[0];
      }
      delete value['terms'];
      delete value['labels'];
      delete value['hiddenLabels'];
    }
    return value;
  });
  return group;
};
